module.exports = __webpack_public_path__ + "img/alexander-redl-d3bYmnZ0ank-unsplash.c87a0b6a.jpg";